import { useState as n, useCallback as C, useEffect as r } from "../external/preact/hooks/dist/hooks.module.js";
const g = ({
  records: s,
  onDataRetrieved: t,
  mergeCustomData: c
}) => {
  const [e, u] = n(s), [f, l] = n(!1), a = C(
    (m) => async () => {
      try {
        const o = t ? await t(m) : [];
        u(c({ records: s, retrievedData: o }));
      } catch (o) {
        u(s), console.error(o);
      } finally {
        l(!1);
      }
    },
    [t, s, c]
  );
  return r(() => {
    t && s.length && (l(!0), a(s)());
  }, [t, a, s]), { customRecords: e, loadingCustomRecords: f };
};
export {
  g as useCustomColumnsData
};
